import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { useBatchQrcode } from '@/hooks/useBatchQrcode'
import { ADOType } from '@/types/types'
import { stationCodeList } from '@/api/station'

import { reactive, computed, ref } from 'vue'
import { BATH_DOWNLOAD_QRCODE_BASE_URL } from '@/common/constants'
import { ElMessage } from 'element-plus'

import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import FormRulesFactory from '@/common/formRules'
const __default__ = defineComponent({
  name: 'EvseDownLoadSelectTypeDialog',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  stationId: {
    type: String,
    default: '',
  },
  selectDownloadList: {
    type: Array,
    default: () => [],
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const { isGenerating, downloadZip } = useBatchQrcode()
const { t } = useI18n()



const formRef = ref()
const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})
const ados = [
  { value: ADOType.ADOT_EVSE, label: t('Operation.evse') },
  { value: ADOType.ADOT_CONNECTOR, label: t('Operation.connector') },
]
const formData = reactive({
  type: '',
})
const rules = reactive({
  ...FormRulesFactory.generateCustomRules(['types'], 'selectNone', 'selectNone'),
})
const download = async () => {
  const { selectDownloadList, stationId } = props
  console.log('selectDownloadList', selectDownloadList)
  const { type } = formData
  const evseList: number[] = []
  const connectorList: number[] = []
  switch (Number(type)) {
    case ADOType.ADOT_EVSE:
      selectDownloadList.forEach((item: any) => {
        evseList.push(item.id)
      })
      break
    case ADOType.ADOT_CONNECTOR:
      selectDownloadList.forEach((item: any) => {
        item.forEach((element: any) => {
          connectorList.push(element.id)
        })
      })
      break
  }
  const { list } = await stationCodeList({
    stationId: stationId,
    ado: type,
    evseId: evseList,
    connectorId: connectorList,
  })
  let codeList: string[] = []
  let snList: string[] = []
  let nameList: string[] = []
  list.forEach((item: any) => {
    codeList.push(item.qrcode)
    snList.push(Number(type) === ADOType.ADOT_EVSE ? item.evseAlias : item.connectorAlias)
    nameList.push(item.sn)
  })
  // console.log(codeList, snList, nameList)
  downloadZip(codeList, snList, nameList)
  ElMessage.success(t('Base.success'))
  showDialog.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    width: "65%",
    class: "upsert-dialog",
    title: _ctx.$t('Operation.downloadQrCode'),
    "z-index": 2000
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showDialog.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: download,
          disabled: !_ctx.$hasPermission('post'),
          loading: _unref(isGenerating)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.confirm')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        "label-position": "top",
        "require-asterisk-position": "right",
        model: _unref(formData),
        rules: _unref(rules)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: _unref(formData).type,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).type) = $event)),
            placeholder: _ctx.$t('formRules.selectNone')
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ados, (item) => {
                return _createVNode(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"])
              }), 64))
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})